<template>
  <div class="px-3 pb-2">
    <v-select
      v-if="config.numerator.valueField && config.numerator.valueField.length"
      :value="numeratorValueField"
      :items="config.numerator.valueField"
      class="px-3"
      item-text="label"
      return-object
      label="Numérateur"
      @change="$store.commit('setAny', { numeratorValueField: $event })"
    />
    <v-select
      v-if="config.denominator.type !== 'none' && config.denominator.valueField && config.denominator.valueField.length > 1"
      :value="denominatorValueField"
      :items="config.denominator.valueField"
      class="px-3"
      item-text="label"
      return-object
      label="Dénominateur"
      @change="$store.commit('setAny', { denominatorValueField: $event })"
    />
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    props: {
      dense: { type: Boolean, default: false },
    },
    computed: {
      ...mapState(['numeratorValueField', 'denominatorValueField']),
      ...mapGetters(['config']),
    },
  }
</script>
